class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      document.dispatchEvent(new Event('cart:updated'));
      document.dispatchEvent(new Event('cart_page:updated'));
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
  const inputValue = parseInt(event.target.value);
  const index = event.target.dataset.index;

  // ✅ NEW: if quantity is 0 → remove item
  if (inputValue === 0 && index) {
    this.updateQuantity(index, 0);
    return;
  }

  let message = '';

  if (inputValue < event.target.dataset.min) {
    message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
  } else if (inputValue > parseInt(event.target.max)) {
    message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
  } else if (inputValue % parseInt(event.target.step) !== 0) {
    message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
  }

  if (message) {
    if (index) {
      this.setValidity(event, index, message);
    }
  } else {
    event.target.setCustomValidity('');
    event.target.reportValidity();
    this.updateQuantity(
      index,
      inputValue,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    );
  }
}


  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    document.dispatchEvent(new Event('cart:updated'));
    document.dispatchEvent(new Event('cart_page:updated'));
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector('collection-variant-grid__container');
            const sourceElement = html.querySelector('.collection-variant-grid__container');
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
}

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    document.dispatchEvent(new Event('cart:updated'));
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        document.dispatchEvent(new Event('cart:updated'));
        document.dispatchEvent(new Event('cart_page:updated'));
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

jQuery(document).on('change', '.block__cart-drawer-selling-option-box select', function (event) {
  event.preventDefault();
  var drawerSellingText = jQuery(this).find("option:selected").text();
  var cartItemSellingPlanID = jQuery(this).val();
  var cartItemIndex = jQuery(this).closest('.cart-item').attr("item-data-index");
  var cartItemQty = jQuery(this).closest('.cart-item').find("quantity-input .quantity__input").val();
  
  updateSellingPlan(cartItemSellingPlanID, cartItemIndex, cartItemQty);
});

function updateSellingPlan(cartItemSellingPlanID, cartItemIndex, cartItemQty) {
  var formData = {
    'line': cartItemIndex,
    'selling_plan': cartItemSellingPlanID,
    'quantity': cartItemQty
  };
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      updateCartDrawer();
      updateCartPage()
      updateCart();
      return response.json();
    })
    
    .catch((error) => {
      console.error('Error:', error);
    });
}


function updateCart() {

  fetch(window.Shopify.routes.root + '?section_id=cart-drawer').then((response) => response.text()).then((responseText) => {
    const cartid = 'CartDrawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.querySelector('#CartDrawer');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    jQuery.ajax({
      url: '/?section_id=cart-icon-bubble',
      type: 'GET',
      dataType: 'html',
      success: function (itemcount) {
        jQuery("#cart-icon-bubble").html(jQuery(itemcount).html());
        // jQuery(".cart-count-bubble").trigger("click");
        jQuery(".drawer").removeClass("is-empty");
        if(jQuery(".main-cart-items").length < 0){
          jQuery(".cart-count-bubble").trigger("click");
        }
        jQuery('[data-popup-item-add]').removeClass('loading');
        jQuery('[data-popup-item-add]').removeClass('disabled');
        jQuery('[data-popup-item-cancel]').removeClass('disabled');
        jQuery("[data-popup-item-cancel]").trigger("click");
        /* Add this code to the cart change event in theme */
        setTimeout(function () {
          if (document.querySelectorAll('.block__drawer-gift-product-item-active:not(.deactive)')) {
            let upchargeItems = [];
            document.querySelectorAll('.block__drawer-gift-product-item-active:not(.deactive)')?.forEach(function (button) {
              upchargeItems.push({
                id: button.getAttribute("data_id"),
                quantity: 1
              });
            });

            let formData = {
              'items': upchargeItems
            };

            if (upchargeItems.length) {
              fetch('/cart/add.js', {
                body: JSON.stringify(formData),
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'xmlhttprequest'
                },
                method: 'POST'
              })
                .then(response => response.json())
                .then(json => {
                  fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
                    .then((response) => response.text())
                    .then((responseText) => {
                      const cartid = 'CartDrawer';
                      const html = new DOMParser().parseFromString(responseText, 'text/html');
                      const destination = document.querySelector('#CartDrawer');
                      const source = html.getElementById(cartid);

                      if (source && destination) {
                        destination.innerHTML = source.innerHTML;
                      }

                      fetch('/?section_id=cart-icon-bubble')
                        .then((response) => response.text())
                        .then((itemcount) => {
                          const cartIconBubble = document.querySelector('#cart-icon-bubble');
                          if (cartIconBubble) {
                            cartIconBubble.innerHTML = itemcount;
                            const drawer = document.querySelector('.drawer');
                            if (drawer) {
                              drawer.classList.remove('is-empty');
                            }
                          }
                        })
                        .catch((error) => {
                          console.error('Error fetching cart icon bubble:', error);
                        });
                    })
                    .catch((error) => {
                      console.error('Error updating cart:', error);
                    });
                })
                .catch(err => {
                  console.error('Error adding product to cart:', err);
                });
            }
          }
        }, 100);
      }
    });
  });
}

$(document).ready(function () {
  document.addEventListener('cart_page:updated', updateCartPage);
  document.addEventListener('cart:updated', updateCartDrawer);
});
function updateCartPage() {
  fetch(`${routes.cart_url}?section_id=main-cart-items`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const sourceElement = html.querySelector('.section-cart');
      const targetElement = document.querySelector('.section-cart');
      if (targetElement && sourceElement) {
        targetElement.replaceWith(sourceElement);
      }
    })
    .catch((e) => {
      console.error(e);
    });
}
function updateCartDrawer() {
  setTimeout(() => {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer', '.drawer__header'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }, 100000);
}
